/* Panier FixeLit
   1. Garde-fou : un cadeau (masque ou brume, 0 €) par lot de 2 packs de clips,
      et plus de ligne « Livraison gratuite » (la livraison est incluse dans chaque pack).
   2. Affichage : nom du pack, photo 8 clips pour le Duo, mention « Cadeau offert »,
      prix barré du Duo = vrai prix de 2 packs (et non le « prix avant réduction » x 2).
   3. Bouton − / + qui ajoute ou retire un pack entier.
   4. Case « Protection d'expédition » (2,99 €, décochée par défaut).
   5. Style épuré du tiroir panier. */
(function () {
  if (window.__fixelitCartGuard) return;
  window.__fixelitCartGuard = true;

  var MAIN_HANDLE = 'clips-draps-fixelit';
  var GIFT_HANDLES = ['masque-sommeil-fixelit', 'brume-draps-fixelit'];
  var REMOVED_HANDLES = ['cadeau-livraison-gratuite', 'cadeau-offert-pack-duo'];
  var PROTECTION_HANDLE = 'protection-expedition';
  var PROTECTION_VARIANT = 58830538473855;
  var DUO_QTY = 2;
  var IMG_8_CLIPS = 'https://cdn.shopify.com/s/files/1/1039/9095/2319/files/ChatGPT_Image_24_juil._2026_18_23_43.png?width=300';
  var nativeFetch = window.fetch.bind(window);
  var timer = null;
  var busy = false;
  var lastCart = null;

  /* ---------- 1. Garde-fou ---------- */

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(run, 400);
  }

  function run() {
    if (busy) return schedule();
    busy = true;
    nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        lastCart = cart;
        decorate();
        var clips = 0;
        var gifts = [];
        var total = 0;
        var updates = {};
        var changed = false;
        cart.items.forEach(function (item) {
          if (item.handle === MAIN_HANDLE) clips += item.quantity;
          if (GIFT_HANDLES.indexOf(item.handle) > -1) { gifts.push(item); total += item.quantity; }
          if (REMOVED_HANDLES.indexOf(item.handle) > -1) { updates[item.key] = 0; changed = true; }
        });
        var excess = total - Math.floor(clips / DUO_QTY);
        for (var i = gifts.length - 1; i >= 0 && excess > 0; i--) {
          var cut = Math.min(gifts[i].quantity, excess);
          updates[gifts[i].key] = gifts[i].quantity - cut;
          excess -= cut;
          changed = true;
        }
        // Protection : une seule, et seulement s'il reste des clips dans le panier.
        cart.items.forEach(function (item) {
          if (item.handle !== PROTECTION_HANDLE) return;
          var wanted = clips > 0 ? 1 : 0;
          if (item.quantity !== wanted) { updates[item.key] = wanted; changed = true; }
        });
        if (!changed) return;

        var drawer = document.querySelector('cart-drawer');
        var body = { updates: updates };
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }
        return nativeFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json(); })
          .then(function (state) {
            if (document.querySelector('cart-items:not(cart-drawer-items)') || /^\/cart\/?$/.test(window.location.pathname)) {
              window.location.reload();
              return;
            }
            if (drawer && state.sections && typeof drawer.renderContents === 'function') {
              drawer.renderContents(state, true);
            }
            schedule();
          });
      })
      .catch(function (err) { console.error('FixeLit cart guard', err); })
      .finally(function () { busy = false; });
  }

  window.fetch = function (input, init) {
    var promise = nativeFetch(input, init);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update|clear)/.test(url)) promise.then(schedule, function () {});
    } catch (e) {}
    return promise;
  };

  /* ---------- 2. Affichage des lignes ---------- */

  function lineQty(line) {
    var input = line.querySelector('.quantity__input');
    return parseInt(line.dataset.quantity || (input && input.value), 10) || 1;
  }

  function setSub(line, name, text) {
    var sub = line.querySelector('.fx-line-sub');
    if (!sub) {
      sub = document.createElement('span');
      sub.className = 'fx-line-sub';
      name.insertAdjacentElement('afterend', sub);
    }
    sub.textContent = text;
  }

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function setText(el, text) {
    if (el && el.textContent.trim() !== text) el.textContent = text;
  }

  /* Un Duo = 2 lots de 4 clips. Quantité paire : on compte en Duo, sinon en lots de 4. */
  function packUnit(qty) {
    return qty % 2 === 0 ? 2 : 1;
  }

  function decoratePack(line) {
    var qty = lineQty(line);
    if (line.dataset.fxDone === String(qty)) return;
    line.dataset.fxDone = String(qty);
    line.classList.add('fx-line', 'fx-line--pack');

    var unit = packUnit(qty);
    var count = qty / unit;
    var title;
    var sub;
    if (unit === 2) {
      title = 'Pack Duo · 8 clips';
      sub = 'Clips de drap-housse FixeLit™ · 2 lits';
    } else if (qty === 1) {
      title = 'Pack Classique · 4 clips';
      sub = 'Clips de drap-housse FixeLit™ · 1 lit';
    } else {
      title = 'Lot de 4 clips';
      sub = 'Clips de drap-housse FixeLit™ · ' + qty * 4 + ' clips au total';
    }
    var name = line.querySelector('.cart-item__name');
    if (name) {
      name.textContent = title;
      setSub(line, name, sub);
    }

    var row = line.querySelector('.cart-drawer-item__quantity-and-prices');
    if (row) {
      var old = row.querySelector('.fx-qty');
      if (old) old.remove();
      var stepper = document.createElement('div');
      stepper.className = 'fx-qty';
      stepper.innerHTML =
        '<button type="button" class="fx-qty__btn" data-fx-step="-1" aria-label="Retirer un pack">−</button>' +
        '<span class="fx-qty__count" aria-live="polite">' + count + '</span>' +
        '<button type="button" class="fx-qty__btn" data-fx-step="1" aria-label="Ajouter un pack">+</button>';
      row.insertBefore(stepper, row.firstChild);
    }

    if (qty >= 2) {
      var img = line.querySelector('.cart-item__image');
      if (img && img.src.indexOf('18_23_43') === -1) {
        img.removeAttribute('srcset');
        img.src = IMG_8_CLIPS;
        img.alt = '8 clips de drap-housse FixeLit';
      }
    }
  }

  /* Duo : prix barré = prix normal des packs (29,99 € x quantité), économies = remise Pack Duo. */
  function decoratePrices() {
    if (!lastCart) return;
    var item = null;
    lastCart.items.forEach(function (i) { if (i.handle === MAIN_HANDLE) item = i; });
    if (!item || item.quantity % 2 !== 0) return;
    document.querySelectorAll('#CartDrawer .cart-item--product-' + MAIN_HANDLE + ' .cart-item__old-price').forEach(function (el) {
      setText(el, money(item.original_line_price));
    });
    var rows = document.querySelectorAll('#CartDrawer .cart-drawer__totals__row');
    if (rows.length > 1) {
      setText(rows[0].querySelector('.cart-drawer__totals__row__money'), money(lastCart.total_discount));
    }
  }

  function decorateGift(line) {
    if (line.dataset.fxDone === 'gift') return;
    line.dataset.fxDone = 'gift';
    line.classList.add('fx-line', 'fx-line--gift');
    var name = line.querySelector('.cart-item__name');
    if (name && !line.querySelector('.fx-pill')) {
      var pill = document.createElement('span');
      pill.className = 'fx-pill';
      pill.textContent = 'Cadeau offert';
      name.insertAdjacentElement('beforebegin', pill);
    }
  }

  /* Case « Protection d'expédition » (2,99 €, décochée par défaut) au-dessus du total. */
  function decorateProtection() {
    var drawer = document.querySelector('#CartDrawer');
    if (!drawer) return;
    var footer = drawer.querySelector('.drawer__footer');
    var hasClips = !!drawer.querySelector('.cart-item--product-' + MAIN_HANDLE);
    var box = drawer.querySelector('.fx-prot');
    if (!footer || !hasClips) {
      if (box) box.remove();
      return;
    }
    var on = !!drawer.querySelector('.cart-item--product-' + PROTECTION_HANDLE);
    if (box && box.dataset.on === String(on)) return;
    if (box) box.remove();
    box = document.createElement('div');
    box.className = 'fx-prot';
    box.dataset.on = String(on);
    box.innerHTML =
      '<button type="button" class="fx-prot__switch" role="checkbox" aria-checked="' + on + '" aria-label="Ajouter la protection d’expédition pour 2,99 €"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="m3.5 8.4 2.9 2.9 6.1-6.6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '<svg class="fx-prot__icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.5 4.5 5.2v6.1c0 4.6 3.1 8.6 7.5 10.2 4.4-1.6 7.5-5.6 7.5-10.2V5.2L12 2.5z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="m8.6 12.2 2.4 2.4 4.6-4.9" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '<div class="fx-prot__text">' +
        '<strong class="fx-prot__title">Protection colis</strong>' +
        '<p class="fx-prot__desc">Perte, vol ou casse : on vous renvoie votre commande</p>' +
      '</div>' +
      '<span class="fx-prot__price">€2,99</span>';
    footer.insertBefore(box, footer.firstChild);
  }

  function toggleProtection(btn) {
    if (busy) return;
    busy = true;
    var box = btn.closest('.fx-prot');
    var turnOn = btn.getAttribute('aria-checked') !== 'true';
    btn.setAttribute('aria-checked', String(turnOn));
    if (box) box.classList.add('fx-busy');
    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && typeof drawer.getSectionsToRender === 'function'
      ? drawer.getSectionsToRender().map(function (s) { return s.id; })
      : null;
    var request = turnOn
      ? nativeFetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: PROTECTION_VARIANT, quantity: 1 }], sections: sections, sections_url: window.location.pathname })
        })
      : nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var updates = {};
            cart.items.forEach(function (item) {
              if (item.handle === PROTECTION_HANDLE) updates[item.key] = 0;
            });
            return nativeFetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ updates: updates, sections: sections, sections_url: window.location.pathname })
            });
          });
    request
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.items && !state.sections) return window.location.reload();
        renderState(state);
      })
      .catch(function (err) { console.error('FixeLit protection', err); })
      .finally(function () { busy = false; });
  }

  // Toute la ligne « Protection colis » est cliquable, pas seulement la case.
  document.addEventListener('click', function (e) {
    var box = e.target.closest && e.target.closest('.fx-prot');
    if (!box) return;
    var btn = box.querySelector('.fx-prot__switch');
    if (!btn) return;
    e.preventDefault();
    toggleProtection(btn);
  });

  function decorate() {
    decorateProtection();
    document.querySelectorAll('.cart-item--product-' + MAIN_HANDLE).forEach(decoratePack);
    GIFT_HANDLES.forEach(function (handle) {
      document.querySelectorAll('.cart-item--product-' + handle).forEach(decorateGift);
    });
    decoratePrices();
  }

  var queued = false;
  function queueDecorate() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; decorate(); });
  }

  /* ---------- 3. Bouton − / + du pack ---------- */

  // Après chaque mise à jour du tiroir, on relit le panier pour garder les prix barrés justes.
  function renderState(state) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && state.sections && typeof drawer.renderContents === 'function') {
      drawer.renderContents(state, true);
      schedule();
    } else {
      window.location.reload();
    }
  }

  function changePack(line, step) {
    if (busy) return;
    busy = true;
    line.classList.add('fx-busy');
    nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var clipsItem = null;
        var gifts = [];
        cart.items.forEach(function (item) {
          if (item.handle === MAIN_HANDLE) clipsItem = item;
          if (GIFT_HANDLES.indexOf(item.handle) > -1) gifts.push(item);
        });
        if (!clipsItem) return;

        var unit = packUnit(clipsItem.quantity);
        var newQty = Math.max(0, clipsItem.quantity + step * unit);
        var updates = {};
        updates[clipsItem.key] = newQty;

        // Un Duo de plus = un cadeau de plus (le même que celui déjà choisi).
        var giftTotal = gifts.reduce(function (sum, g) { return sum + g.quantity; }, 0);
        if (step > 0 && unit === 2 && gifts.length) {
          updates[gifts[0].key] = gifts[0].quantity + 1;
          giftTotal += 1;
        }
        // Un Duo de moins : on retire les cadeaux en trop.
        var excess = giftTotal - Math.floor(newQty / DUO_QTY);
        for (var i = gifts.length - 1; i >= 0 && excess > 0; i--) {
          var current = updates[gifts[i].key] !== undefined ? updates[gifts[i].key] : gifts[i].quantity;
          var cut = Math.min(current, excess);
          updates[gifts[i].key] = current - cut;
          excess -= cut;
        }

        var drawer = document.querySelector('cart-drawer');
        var body = { updates: updates };
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }
        return nativeFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json(); })
          .then(renderState);
      })
      .catch(function (err) { console.error('FixeLit pack stepper', err); })
      .finally(function () {
        busy = false;
        line.classList.remove('fx-busy');
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.fx-qty__btn');
    if (!btn) return;
    e.preventDefault();
    var line = btn.closest('.cart-item');
    if (line) changePack(line, parseInt(btn.dataset.fxStep, 10));
  });

  /* ---------- 4. Style épuré du tiroir panier ---------- */

  // Préfixe plus précis que le bloc « fx_panier_confiance » du thème, pour passer devant ses règles.
  var P = 'html body #CartDrawer ';

  function injectStyle() {
    if (document.getElementById('fx-cart-qty-style')) return;
    var style = document.createElement('style');
    style.id = 'fx-cart-qty-style';
    style.textContent =
      '.fx-qty{display:inline-flex;align-items:center;height:32px;border:1px solid #D9D2C7;border-radius:999px;background:#FFFFFF;padding:0 2px;align-self:center}' +
      '.fx-qty__btn{width:28px;height:28px;border:0;border-radius:50%;background:transparent;color:#2B2A28;font-size:1.6rem;font-weight:600;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0}' +
      '.fx-qty__btn:hover{background:#F1EBE3}' +
      '.fx-qty__count{min-width:22px;text-align:center;font-size:1.4rem;font-weight:700;color:#2B2A28}' +
      '.fx-line--pack .cart-drawer-item__quantity-and-prices{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-top:8px}' +
      '.fx-busy{opacity:.55;pointer-events:none;transition:opacity .2s}' +
      '#CartDrawer .cart-item--product-' + PROTECTION_HANDLE + '{display:none !important}' +
      // En-tête et lignes : plus de cartes, de simples séparateurs.
      P + '.drawer__header{padding-bottom:14px;border-bottom:1px solid #ECE6DE}' +
      P + '.drawer__heading{font-size:1.9rem !important;font-weight:800}' +
      P + '.cart-items{gap:0 !important}' +
      P + '.cart-drawer-item{background:transparent !important;border:0 !important;border-bottom:1px solid #ECE6DE !important;border-radius:0 !important;padding:16px 0 !important;margin:0 !important}' +
      P + '.cart-item__image{border-radius:8px;background:#F1EBE3}' +
      P + '.cart-item__name{font-size:1.5rem !important;font-weight:700;line-height:1.3}' +
      P + '.fx-line-sub{margin-top:2px;font-size:1.2rem;color:#8A857E}' +
      P + '.cart-drawer-item__saving{display:none !important}' +
      P + '.cart-item__totals .regular-price{font-size:1.5rem;font-weight:800;color:#2B2A28}' +
      P + '.cart-item__totals .compare-price{font-size:1.2rem;color:#A39E97}' +
      P + '.cart-drawer-item__cart-remove-button .button{opacity:.45}' +
      // Cadeau : simple ligne, sans encadré ni prix à 0 €.
      P + '.cart-drawer-item.fx-line--gift{padding:12px 0 !important}' +
      P + '.fx-line--gift .cart-item__totals{display:none !important}' +
      P + '.fx-line--gift .cart-item__name{font-size:1.35rem !important;font-weight:600}' +
      P + '.fx-pill{display:block;width:max-content;margin:0 0 3px;padding:0;background:none;color:#A07A52;font-size:1.05rem;font-weight:800;letter-spacing:.08em;line-height:1.4}' +
      // Protection : ligne compacte avec case à cocher.
      '.fx-prot{display:flex;align-items:center;gap:12px;margin:2px 0 14px;padding:12px 14px;border:1px solid #E4DDD3;border-radius:12px;background:#FFFFFF;cursor:pointer;transition:border-color .2s}' +
      '.fx-prot[data-on="true"]{border-color:#1F3A4D}' +
      '.fx-prot__switch{flex:none;width:22px;height:22px;padding:0;border:1.5px solid #B9B2A7;border-radius:6px;background:#FFFFFF;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:background .2s,border-color .2s}' +
      '.fx-prot__switch svg{width:14px;height:14px;color:#FFFFFF;opacity:0}' +
      '.fx-prot__switch[aria-checked="true"]{background:#1F3A4D;border-color:#1F3A4D}' +
      '.fx-prot__switch[aria-checked="true"] svg{opacity:1}' +
      '.fx-prot__icon{flex:none;width:22px;height:22px;color:#1F3A4D}' +
      '.fx-prot__text{flex:1;min-width:0}' +
      '.fx-prot__title{display:block;font-size:1.35rem;font-weight:700;line-height:1.3;color:#2B2A28}' +
      '.fx-prot__desc{margin:2px 0 0;font-size:1.15rem;line-height:1.35;color:#8A857E}' +
      '.fx-prot__price{flex:none;font-size:1.35rem;font-weight:700;color:#1F3A4D}' +
      // Pied du panier : économies mises en avant, bouton arrondi, réassurance discrète.
      P + '.drawer__footer{border-top:1px solid #ECE6DE}' +
      P + '.cart-drawer__totals__row:not(:last-child){color:#B4532A !important}' +
      P + '.cart__checkout-button,' + P + '.cart__checkout-button:before,' + P + '.cart__checkout-button:after{border-radius:999px !important}' +
      P + '.cart__checkout-button{min-height:52px;font-size:1.6rem;letter-spacing:.06em;text-transform:uppercase}' +
      P + '.fx-confiance{margin-top:0;gap:2px 10px;font-size:1.1rem}' +
      P + '.payment-badges-block{margin-top:6px !important}' +
      P + '.payment-badges{gap:4px;justify-content:center}' +
      P + '.payment-badges svg{width:32px;height:20px}';
    document.head.appendChild(style);
  }

  function start() {
    injectStyle();
    decorate();
    new MutationObserver(queueDecorate).observe(document.body, { childList: true, subtree: true });
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
